export class EmailAttribute {
    private static emailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    public static hasError(value: string): boolean {
        if (!value || !this.emailReg.test(value)) {
            return true;
        }
        return false;
    }

    public static getErrorMessage(): string {
        return "Indtast en gyldigt e-mail adresse";
    }
}